import { apiClient } from './apiClient';

const mapBranchFromApi = (b, idx) => ({
  localKey: b.id != null ? `b-${b.id}` : `new-${idx}`,
  id: b.id ?? null,
  label: b.label || `Branch ${idx + 1}`,
  companyName: b.companyName || '',
  address: b.address || '',
  country: b.country || '',
  state: b.state || '',
  city: b.city || '',
  pincode: b.pincode || '',
  contactNo1: b.contactNo1 || '',
  contactNo2: b.contactNo2 || '',
  email: b.email || '',
  website: b.website || '',
  panNo: b.panNo || '',
  gstNo: b.gstNo || '',
  ifcCode: b.ifcCode || '',
  regCin: b.regCin || '',
  lutNo: b.lutNo || '',
  companyLogo: null,
  logoPreview: b.companyLogo || null,
  bankDetails: Array.isArray(b.bankDetails)
    ? b.bankDetails.map((row) => ({
        id: row.id,
        bankName: row.bankName || '',
        branchName: row.branchName || '',
        ifscCode: row.ifscCode || '',
        account: row.account || '',
        address: row.address || '',
        swiftCode: row.swiftCode || '',
        currencyId: row.currencyId ?? row.currency?.id ?? '',
      }))
    : [],
  intermediaryBank: {
    bankName: b.intermediaryBank?.bankName || '',
    routedThrough: b.intermediaryBank?.routedThrough || '',
    accountName: b.intermediaryBank?.accountName || '',
  },
});

export const normalizeCompanyPayload = (data) => {
  if (!data || !Array.isArray(data.branches)) return data;
  return {
    ...data,
    branches: data.branches.map((b, i) => mapBranchFromApi(b, i)),
  };
};

const emptyBranch = (label, localKey) => ({
  localKey,
  id: null,
  label,
  companyName: '',
  address: '',
  country: '',
  state: '',
  city: '',
  pincode: '',
  contactNo1: '',
  contactNo2: '',
  email: '',
  website: '',
  panNo: '',
  gstNo: '',
  ifcCode: '',
  regCin: '',
  lutNo: '',
  companyLogo: null,
  logoPreview: null,
  bankDetails: [],
  intermediaryBank: {
    bankName: '',
    routedThrough: '',
    accountName: '',
  },
});

export const getCompanyDetails = async () => {
  try {
    const response = await apiClient.get(`/api/v1/company`);
    const data = response.data.data || null;
    if (!data || !Array.isArray(data.branches) || data.branches.length === 0) {
      return null;
    }
    return normalizeCompanyPayload(data);
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    console.error('Failed to fetch company details:', error);
    return null;
  }
};

export { emptyBranch };

export const saveCompanyDetails = async (branches) => {
  const payload = branches.map((b) => ({
    id: b.id || undefined,
    label: b.label,
    companyName: b.companyName,
    address: b.address,
    country: b.country,
    state: b.state,
    city: b.city,
    pincode: b.pincode,
    contactNo1: b.contactNo1,
    contactNo2: b.contactNo2 || '',
    email: b.email,
    website: b.website || '',
    panNo: b.panNo,
    gstNo: b.gstNo,
    regCin: b.regCin,
    ifcCode: b.ifcCode,
    lutNo: b.lutNo,
    intermediaryBank: b.intermediaryBank,
    bankDetails: (b.bankDetails || []).map((row) => ({
      bankName: row.bankName,
      branchName: row.branchName,
      ifscCode: row.ifscCode,
      account: row.account,
      swiftCode: row.swiftCode || '',
      address: row.address,
      currencyId: row.currencyId === '' || row.currencyId == null ? null : Number(row.currencyId),
    })),
  }));

  const hasFile = branches.some((b) => b.companyLogo instanceof File);

  if (hasFile) {
    const data = new FormData();
    data.append('branches', JSON.stringify(payload));
    branches.forEach((b, i) => {
      if (b.companyLogo instanceof File) {
        data.append(`branch_logo_${i}`, b.companyLogo);
      }
    });
    const response = await apiClient.post(`/api/v1/company`, data);
    return response.data;
  }

  const response = await apiClient.post(`/api/v1/company`, { branches: payload });
  return response.data;
};
